import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { formatDateTime } from '../../utils/dateUtils';

/** Small metric tile — value on top, label below. */
export function MetricBox({ value, label }: { value: number; label: string }) {
  return (
    <div className="min-w-14 bg-neutral-50 border border-neutral-100 rounded px-2 py-1.5">
      <div className="text-base font-semibold text-neutral-900 leading-none">{value}</div>
      <div className="text-2xs text-neutral-500 mt-0.5">{label}</div>
    </div>
  );
}

/** Collapsible workspace-level AI brief. */
export function WorkspaceBriefPanel({
  brief,
  generatedAt,
}: {
  brief: string;
  generatedAt: string;
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border border-neutral-200 rounded-lg bg-white overflow-hidden mb-6">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between px-4 py-3 text-sm font-semibold text-neutral-700 hover:bg-neutral-50 transition"
        aria-expanded={open}
      >
        <span>Workspace Brief</span>
        {open ? (
          <ChevronDown className="w-4 h-4 text-neutral-400" />
        ) : (
          <ChevronRight className="w-4 h-4 text-neutral-400" />
        )}
      </button>
      {open ? (
        <div className="px-4 pb-4">
          <p className="whitespace-pre-wrap text-sm text-neutral-700">{brief}</p>
          {generatedAt ? (
            <p className="text-2xs text-neutral-400 mt-2">Generated {formatDateTime(generatedAt)}</p>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
